export const MESSAGE_SET = 'MESSAGE_SET';
export const MESSAGE_REMOVE = 'MESSAGE_REMOVE';



// WEBPACK FOOTER //
// ./src/app/actions/messages/types.js